/**
 * Configurações do ambiente de desenvolvimento
 * yarn start
 */
const devConfig = {
  env: "dev",
  hosts: {
    auth: "https://apidev.sefaz.rn.gov.br/autbasic/",
    cadastros: "https://apidev.sefaz.rn.gov.br/cadastros/",
    fiscalizacao: "https://apidev.sefaz.rn.gov.br/fiscalizacao/",
    usuarios: "https://apidev.sefaz.rn.gov.br/usuarios/",
    extratofiscal: "https://apidev.sefaz.rn.gov.br/extrato/",
    nfp: "https://apidev.sefaz.rn.gov.br/nfp/",

    // LOCAL
    // auth: 'https://apihom2.set.rn.gov.br/autbasic/',
    // cadastros: 'https://apihom2.set.rn.gov.br/cadastros/',
    // fiscalizacao: "http://localhost:50666/",
    // usuarios: "http://localhost:59899/",
    // extratofiscal: "http://localhost:51984/",
    // nfp: "http://localhost:55588/",
  },
};

export default devConfig;
